// @flow
import React from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import { resetCheckSession, checkSession } from "../actions/auth";
import AppInstallBanner from "../containers/app-install-banner/AppInstallBanner";
import { FirebaseContext } from '../context/firebase';
import { GUEST_ROUTES } from "../constants";
import config from '../config';

const routes = ['/payment', '/cart' , '/process-payment', '/process-wallet-payment']
const Auth = WrappedComponent => {
  class AuthWrapper extends React.Component<any, any> {
    static contextType: React$Context<any>;

    hiddenBannerRoutes(pathname) {
      return routes.find(route => pathname.includes(route));
    }

    authenticateRoute() {
      const {
        auth: { sessionId } = {},
        user: { mobile} = {},
        location: {pathname} = {},
      } = this.props; 

      const guestRoute = GUEST_ROUTES.find(route => pathname.includes(route));
      if (guestRoute && config.guest_mode) {
        return true;
      }

      return sessionId && mobile;
    }

    render() {
      const {
        location,
        serviceWorker: {  hideInstallBanner, appInstalled } = {}
      } = this.props;
      const showBanner = !hideInstallBanner && !appInstalled && !this.hiddenBannerRoutes(location.pathname);
      return this.authenticateRoute() ? (
        <React.Fragment>
          { 
            showBanner && 
            <section style={{
              position: 'fixed',
              width: '100vw',
              top: '0',
              height:  "50px",
              opacity:  !showBanner ? 0 : 1,
              transition: "all 0.5s ease-out",
              zIndex: !showBanner ? -1 : 1,
              transform: `translateY(${!showBanner ? '-50px': 0 })`
            }}> 
              <AppInstallBanner /> 
            </section>
          }
          <section
            style={{
              minHeight: !showBanner ? "100vh" : "calc(100vh - 50px)",
              position: 'relative',
              top: !showBanner ? "0" : "50px",
              transition: "all 0.5s ease-out",
            }}
          >
            <WrappedComponent {...this.props} />
          </section>
        </React.Fragment>
      ) : (
        <Redirect to={{ pathname: "/login", state: { from: location } }} />
      );
    }

    componentWillUnmount() {
      // this.props.resetCheckSession();
    }
  };

  AuthWrapper.contextType = FirebaseContext;
  return AuthWrapper;
};

const mapStateToProps = (state, props) => {
  return {
    auth: state.auth,
    user: state.user,
    serviceWorker: state.serviceWorker,
    ...props
  };
};

export default compose(
  connect(mapStateToProps, { resetCheckSession, checkSession }),
  Auth
);
